import React, { useState } from "react"
import { styles } from "../styles";
import EmailForm from "./EmailForm";
import ChatEngine from "./ChatEngine";

const SupportWindow = props => {
    const [user, setUser] = useState(null)
    const [chat, setChat] = useState(null)

    return (
        <div 
            className='support-window-wrapper transition-5'
            style={{
                ...styles.supportWindow,
                ...{ 
                    opacity: props.visible ? '1' : '0',
                    pointerEvents: props.visible ? 'auto' : 'none'
                }
            }}
        >
            {/* Blinking Circles */}
            <div className="blinking-circle blinking-circle-1"></div>
            <div className="blinking-circle blinking-circle-2"></div>
            
            <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden', borderRadius: '12px' }}>
                <EmailForm 
                    visible={user === null || chat === null}
                    setUser={user => setUser(user)} 
                    setChat={chat => setChat(chat)} 
                />

                <ChatEngine 
                    visible={user !== null && chat !== null}
                    user={user} 
                    chat={chat} 
                />
            </div>
        </div>
    )
}

export default SupportWindow;
